/* CleanScore front end: entry point and hash router. Bundled by build.mjs
   into dist/app.js. */

import { initAuth } from "./auth";
import { byId } from "./dom";
import { icon } from "./icons";
import { leaveScreen } from "./motion";
import { registerServiceWorker, wireInstallPrompt, wireOfflineBar } from "./pwa";
import { wireScannerDialog } from "./scan-dialog";
import { homeView } from "./home";
import { searchView } from "./search";
import { analyseView, compareView, howView, recentView, resultView, scanNow } from "./views";

type Tab = "home" | "analyse" | "compare" | "recent" | "";

function setTab(tab: Tab): void {
  document.querySelectorAll<HTMLElement>(".nav-item").forEach((a) => {
    a.classList.toggle("active", a.dataset.tab === tab);
    if (a.dataset.tab === tab) a.setAttribute("aria-current", "page");
    else a.removeAttribute("aria-current");
  });
}

function route(): void {
  const main = byId("view");
  const [path = "/", query = ""] = location.hash.slice(1).split("?");
  const params = new URLSearchParams(query);
  const parts = path.split("/").filter(Boolean);
  leaveScreen();

  switch (parts[0] ?? "") {
    case "analyse":
      analyseView(main, params);
      setTab("analyse");
      break;
    case "search":
      searchView(main, params);
      setTab("");
      break;
    case "compare":
      compareView(main);
      setTab("compare");
      break;
    case "result":
      resultView(main, parts[1] ?? "");
      setTab("");
      break;
    case "recent":
      recentView(main);
      setTab("recent");
      break;
    case "how":
      howView(main);
      setTab("");
      break;
    default:
      homeView(main);
      setTab("home");
  }
  document.body.dataset.route = parts[0] ?? "home";
  window.scrollTo({ top: 0 });
}

function drawNav(): void {
  byId("nav").innerHTML = `
    <a class="nav-item" data-tab="home" href="#/">${icon("home")}<span>Home</span></a>
    <a class="nav-item" data-tab="analyse" href="#/analyse">${icon("analyse")}<span>Analyse</span></a>
    <button class="nav-scan" type="button" aria-label="Scan a barcode">${icon("scan")}</button>
    <a class="nav-item" data-tab="compare" href="#/compare">${icon("compare")}<span>Compare</span></a>
    <a class="nav-item" data-tab="recent" href="#/recent">${icon("clock")}<span>Recent</span></a>`;
  document.querySelector(".nav-scan")?.addEventListener("click", scanNow);
  byId("howLink").innerHTML = `${icon("shield")}<span>How we grade</span>`;
}

/** Long enough for the intro to play, short enough not to be in the way. */
const SPLASH_MS = 1700;

function hideSplash(): void {
  const splash = document.getElementById("splash");
  if (!splash) return;
  if (document.documentElement.classList.contains("no-splash")) {
    splash.remove();
    return;
  }
  const wait = Math.max(0, SPLASH_MS - performance.now());
  window.setTimeout(() => {
    splash.classList.add("out");
    window.setTimeout(() => splash.remove(), 700);
  }, wait);
}

function start(): void {
  drawNav();
  wireScannerDialog();
  window.addEventListener("hashchange", route);
  route();
  hideSplash();
  registerServiceWorker();
  wireInstallPrompt();
  wireOfflineBar();
  void initAuth();
}

start();
